<template>
  <li class="navigation-nested-list">
    <details class="navigation-nested-list__detail" :open="isOpen">
      <summary class="navigation-nested-list__summary">
        <div
          class="navigation_item"
          :class="{ 'navigation_item--active': isActive }"
        >
          <span class="navigation_item__name">
            <span class="navigation_item__icon"><slot name="icon"></slot></span>
            <span class="navigation_item__contents"
              ><slot name="title"></slot
            ></span>
          </span>
          <span class="navigation_item__nesting_indicator">
            <FontAwesomeIcon :icon="['far', 'chevron-right']" />
          </span>
        </div>
      </summary>
      <ul class="navigation-nested-list__list">
        <slot></slot>
      </ul>
    </details>
  </li>
</template>

<script>
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faChevronRight);

/**
 * @group Navigation
 * Nested Navigation List. Supposed to be nested within NavigationList.
 * This component utilities the <strong>details</strong> semantic HTML element to hide and show
 * its contents to the user that clicks the <strong>summary</strong> tag.
 */
export default {
  name: "NavigationNestedList",
  components: {
    FontAwesomeIcon,
  },
  props: {
    /**
     * Flag to apply isActive type of styling on parent element of list.
     */
    isActive: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag that sets open state for initial render.
     */
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style_variables/style_variables.scss";
.navigation-nested-list__detail[open] {
  .navigation_item__nesting_indicator {
    transform: rotateZ(90deg);
  }
}
.navigation-nested-list__summary {
  display: block;
  cursor: pointer;
}
.navigation-nested-list__summary::-webkit-details-marker,
.navigation-nested-list__summary::marker {
  display: none;
}
.navigation_item {
  @extend %body2_style;
  line-height: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-decoration: none;
  width: calc(100% + 1px);
  height: 48px;
  padding: 0px 24px;
  border-right: 2px solid rgba($white, 0);

  &.navigation_item--active {
    background: rgba($blue, 0.05);
    border-right: 2px solid $blue;
    .navigation_item__icon {
      color: $blue;
    }
  }
}
.navigation-nested-list__list {
  padding: 0px;
  list-style: none;
  margin-top: 8px;
}
.navigation_item__name {
  width: 100%;
  display: inline-block;
  line-height: 20px;
  user-select: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.navigation_item__icon {
  display: inline-block;
  margin-right: 20px;
  width: 20px;
  height: 16px;
}
.navigation_item__contents {
  width: 100%;
  display: inline;
  padding-left: 4px;
}
.navigation_item__nesting_indicator {
  width: 6px;
  transition: all 150ms;
  font-size: 12px;
  display: inline;
}
</style>
